/**
 * Плитка типу файлу у вкладці «Файли» (прототип v4): розширення великими літерами (до 4 знаків) і суцільний тон — PDF помаранчевий,
 * документи синій, таблиці зелений, зображення фіолетовий, решта сірий (токени --solid-* з tokens.css). Чиста функція.
 */
export function fileTone(fileName: string, mimeType: string): { ext: string; tone: string } {
  const dot = fileName.lastIndexOf('.');
  const ext = (dot > 0 ? fileName.slice(dot + 1) : '').toUpperCase().slice(0, 4) || 'FILE';
  const kind = `${ext} ${mimeType}`.toLowerCase();
  if (kind.includes('pdf')) return { ext, tone: 'var(--solid-orange)' };
  if (/\b(doc|docx|odt|rtf)\b|word/.test(kind)) return { ext, tone: 'var(--solid-blue)' };
  if (/\b(xls|xlsx|ods|csv)\b|sheet|excel/.test(kind)) return { ext, tone: 'var(--solid-green)' };
  if (kind.includes('image')) return { ext, tone: 'var(--solid-purple)' };
  return { ext, tone: 'var(--solid-grey)' };
}
